'use strict';

var registerInterfaceWithDefaultTheme = require('../../../../_virtual/registerInterfaceWithDefaultTheme.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
require('../../../react-with-styles/lib/ThemedStyleSheet.js');
require('../theme/DefaultTheme.js');
var DefaultTheme = require('../../../../_virtual/DefaultTheme.js_commonjs-exports2.js');
var ThemedStyleSheet = require('../../../../_virtual/ThemedStyleSheet.js_commonjs-exports.js');

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerInterfaceWithDefaultTheme;

var _ThemedStyleSheet = _interopRequireDefault(ThemedStyleSheet.__exports);

var _DefaultTheme = _interopRequireDefault(DefaultTheme.__exports);

function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
  _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);

  _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
}
}(registerInterfaceWithDefaultTheme.__exports));
